import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountInvoiceHistoryPage} from '../../../../../../features/credit/pages/CreditAccountInvoiceHistoryPage/CreditAccountInvoiceHistoryPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/invoices',
)({
  component: CreditAccountInvoiceHistoryPage,
  staticData: {crumbKey: 'navigation.invoices'},
});
